export interface ApiDataResponse<T> {
  data: T;
  recordsFiltered: number;
  recordsTotal: number;
}
